.box {
	composes: menu from './Menu.module.css';
}

.item {
	composes: item from './Menu.module.css';
}

.content {
	composes: content from './Menu.module.css';
}
